import { VehicleNumberPlate } from '../types';

export interface INumberPlatePrice {
	price: number;

	reasons: {
		name: string;
		price: number;
	}[];
}

export interface ICalculateNumberPlateOptions {
	buyPriceBase: number;
	buyPrice3Letters: number;
	buyPrice3Numbers: number;
	donateBuyPriceBase: number;
	donateBuyPrice3Letters: number;
	donateBuyPrice3Numbers: number;
}

function getMaxRepeatingCount(str: string) {
	const counts: Record<string, number> = {};
	for (const char of str) {
		counts[char] = (counts[char] || 0) + 1;
	}
	const countsArr = Object.values(counts);
	return countsArr.length ? Math.max(...countsArr) : 0;
}

/**
 * Подсчитывает цену покупки номерного знака
 */
export function calculateNumberPlatePrice(
	numberPlate: VehicleNumberPlate,
	config: ICalculateNumberPlateOptions,
	isDonate = false,
): INumberPlatePrice {
	const result: INumberPlatePrice = {
		price: isDonate ? config.donateBuyPriceBase : config.buyPriceBase,
		reasons: [],
	};

	result.reasons.push({
		name: 'Базовая цена',
		price: isDonate ? config.donateBuyPriceBase : config.buyPriceBase,
	});

	const isSameLetters = getMaxRepeatingCount(numberPlate.text.replace(/[0-9]/g, '')) >= 3;
	if (isSameLetters) {
		result.price += isDonate ? config.donateBuyPrice3Letters : config.buyPrice3Letters;
		result.reasons.push({
			name: '3 повторяющиеся буквы',
			price: isDonate ? config.donateBuyPrice3Letters : config.buyPrice3Letters,
		});
	}

	const isSameNumbers = getMaxRepeatingCount(numberPlate.text.replace(/[^0-9]/g, '')) >= 3;
	if (isSameNumbers) {
		result.price += isDonate ? config.donateBuyPrice3Numbers : config.buyPrice3Numbers;
		result.reasons.push({
			name: '3 повторяющиеся цифры',
			price: isDonate ? config.donateBuyPrice3Numbers : config.buyPrice3Numbers,
		});
	}

	return result;
}
